import { ReactNode } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { ToastContainer } from 'react-toastify';
import { LinkComponentType, MainContext, NavigationContextProvider } from '@restworld/utils-common';
import { AuthFlowModals } from './auth-flow-modals';
import { AUTH_TOAST_CONTAINER_ID } from './auth-flow';
import { SocialUserTypeModal } from '../components/Login/social-user-type-modal';
import { GlobalJobPositionPreferencesModal } from './global-job-position-preferences-modal';
import WorkerEntryPointModal from '../components/worker-entry-point/worker-entry-point-modal';

export const MainContextWrapper = ({ children }: { children: React.ReactNode }) => (
  <NavigationProviderWrapper>
    <MainContext>
      {children}
      <AuthFlowModals />
      <SocialUserTypeModal />
      {/* Entry point for screens that do not mount one themselves, the login page
          and the login modal above. It sits beside AuthFlowModals rather than
          inside the login form because opening it closes that form, which would
          take the modal down with it. Renders nothing until
          `openStandaloneUploadCvEntryPoint` is fired. */}
      <WorkerEntryPointModal standalone />
      <GlobalJobPositionPreferencesModal />
      {/* Dedicated container so auth toasts float above the login modal/drawer
          (z-[100]). Mirrors the shared toast styling; only position + z differ. */}
      <ToastContainer
        containerId={AUTH_TOAST_CONTAINER_ID}
        position="top-center"
        autoClose={false}
        hideProgressBar={true}
        closeOnClick={true}
        pauseOnHover={true}
        closeButton={false}
        style={{ boxShadow: 'none', padding: 0, background: 'none', width: 'fit-content', zIndex: 9999 }}
      />
    </MainContext>
  </NavigationProviderWrapper>
);
const NavigationProviderWrapper = ({ children }: { children: ReactNode }) => {
  const router = useRouter();
  return (
    <NavigationContextProvider linkComponent={Link as LinkComponentType} router={router}>
      {children}
    </NavigationContextProvider>
  );
};
